
<div class="d-inline-block" >
    <canvas #barChartCanvas class="customWidth"></canvas>
</div>

